import { BsHouseDoor } from "react-icons/bs";
import { RiServiceLine } from "react-icons/ri";
import { AiOutlineLock, AiOutlinePieChart } from "react-icons/ai";
import { FaCity, FaUserShield, FaPeopleArrows, FaPlaceOfWorship, FaRobot } from "react-icons/fa";
import { MdPayment, MdOutlineStairs, MdAdminPanelSettings, MdOutlineBeachAccess, MdOutlineBusinessCenter, MdSettingsSystemDaydream } from "react-icons/md";

export const __ROUTES__ = Object.freeze({
    home: "/", regionDash: "/region", regionSettings: "/region/manage",
    countriesDash: "/countries/dashboard", countriesSettings: "/countries",
    levelDash: "/levels/dashboard", levelSettings: "/levels/first", page: "/page",
    team: "/team", newsletter: "/newsletter", admin: "/admin", user: "/user",
    tourPackage: "/tourpackage", product: "/product", agent: "/agent", banner: "/banner",
    citiesSettings: "/cities", citiesDasb: "/cities/dashboard", tradeOrganization: "/trade/org",
    regionalBlocks: "/regional/blocks", plugImage: "/plug/image", climate: "/climate",
    ethnicGroup: "/ethnic/group", language: "/language", religion: "/religion", footer: "/footer",
    aiChatInfo: "/ai_chat_info", contact: "/contact", about: "/about", service: "/service",
    partner: "/partner", blog: "/blog", email: "/email", company: "/company", search: "/search",
    terms: "/terms", privacy: "/privacy", contentStats: "/content/stats", adminsStats: "/content/admin/stats",
    password: "/password", payment: "/payment", currency: "/currency", generatedEvents: "/generated",
    chatSupport: "/chat_support",
});

const R = __ROUTES__;

// Grouped Menu Configuration
export const MenuCategories = [
    {
        label: "Overview",
        items: [
            {
                title: "Dashboard", icon: <BsHouseDoor />,
                roles: ["admin", "super_admin", "content_admin", "content_creator", "company_owner", "system_admin"],
                menu: [{ title: "Dashboard Overview", ref: R.home }, { title: "Global Search", ref: R.search, roles: ["admin", "super_admin"] }],
            },
            {
                title: "My Statistics", icon: <AiOutlinePieChart />,
                roles: ["admin", "super_admin", "content_admin", "content_creator", "company_owner", "system_admin"],
                menu: [{ title: "View Statistics", ref: R.contentStats }],
            }
        ]
    },
    {
        label: "Destinations",
        items: [
            {
                title: "Regions", icon: <FaPlaceOfWorship />, roles: ["admin", "super_admin"],
                menu: [{ title: "Dashboard", ref: R.regionDash }, { title: "Manage Regions", ref: R.regionSettings }],
            },
            {
                title: "Countries", icon: <FaPeopleArrows />,
                roles: ["admin", "super_admin", "content_admin", "content_creator", "company_owner", "system_admin"],
                menu: [{ title: "Dashboard", ref: R.countriesDash }, { title: "Manage Countries", ref: R.countriesSettings }],
            },
            {
                title: "Cities", icon: <FaCity />,
                roles: ["admin", "super_admin", "content_admin", "content_creator", "company_owner", "system_admin"],
                menu: [{ title: "Dashboard", ref: R.citiesDasb }, { title: "Manage Cities", ref: R.citiesSettings }],
            }
        ]
    },
    {
        label: "Content & Data",
        items: [
            {
                title: "Pages & Blog", icon: <RiServiceLine />,
                roles: ["admin", "super_admin", "content_admin", "content_creator", "company_owner", "system_admin"],
                menu: [{ title: "Pages", ref: R.page }, { title: "Banner Images", ref: R.banner }, { title: "Blog", ref: R.blog }],
            },
            {
                title: "Additional Data", icon: <MdOutlineBeachAccess />, roles: ["admin", "super_admin"],
                menu: [
                    { title: "Trade Organizations", ref: R.tradeOrganization }, { title: "Regional Blocks", ref: R.regionalBlocks },
                    { title: "Plug Images", ref: R.plugImage }, { title: "Climates", ref: R.climate },
                    { title: "Ethnic Groups", ref: R.ethnicGroup }, { title: "Languages", ref: R.language }, { title: "Religions", ref: R.religion },
                ],
            },
            {
                title: "Our Levels", icon: <MdOutlineStairs />, roles: ["admin", "super_admin"],
                menu: [{ title: "Dashboard", ref: R.levelDash }, { title: "Manage Levels", ref: R.levelSettings }],
            },
            {
                title: "AI Generation", icon: <FaRobot />, roles: ["super_admin"],
                menu: [{ title: "Manage Content", ref: R.generatedEvents }, { title: "Chat Support", ref: R.chatSupport }],
            }
        ]
    },
    {
        label: "People & Companies",
        items: [
            {
                title: "Admins & Stats", icon: <MdAdminPanelSettings />,
                roles: ["admin", "super_admin", "content_admin", "company_owner", "system_admin"],
                menu: [{ title: "Admins Settings", ref: R.admin, roles: ["admin", "super_admin", "company_owner", "system_admin"] }, { title: "Admins Statistics", ref: R.adminsStats }],
            },
            {
                title: "Users / Agents", icon: <FaUserShield />, roles: ["admin", "super_admin"],
                menu: [{ title: "Agents", ref: R.agent }, { title: "Users", ref: R.user }, { title: "Team", ref: R.team }],
            },
            {
                title: "Companies", icon: <MdOutlineBusinessCenter />, roles: ["admin", "super_admin", "company_owner"],
                menu: [{ title: "Manage Companies", ref: R.company }],
            }
        ]
    },
    {
        label: "Settings & Billing",
        items: [
            {
                title: "Edit Sitepages", icon: <MdSettingsSystemDaydream />, roles: ["admin", "super_admin"],
                menu: [
                    { title: "About Us", ref: R.about }, { title: "Footer", ref: R.footer }, { title: "Ai Chat Info", ref: R.aiChatInfo },
                    { title: "Contact Us", ref: R.contact }, { title: "Email Templates", ref: R.email }, { title: "Our Service", ref: R.service },
                    { title: "Our Partners", ref: R.partner }, { title: "Terms & Conditions", ref: R.terms }, { title: "Privacy Policy", ref: R.privacy },
                ],
            },
            {
                title: "Payments", icon: <MdPayment />, roles: ["admin", "super_admin", "company_owner", "system_admin"],
                menu: [{ title: "Payments History", ref: R.payment, roles: ["admin", "super_admin", "company_owner", "system_admin"] }],
            },
            {
                title: "Subscriptions", icon: <MdPayment />, roles: ["admin", "super_admin"],
                menu: [{ title: "Newsletter", ref: R.newsletter }],
            },
            {
                title: "Account Security", icon: <AiOutlineLock />,
                roles: ["admin", "super_admin", "content_admin", "content_creator", "company_owner", "system_admin"],
                menu: [{ title: "Update Password", ref: R.password }],
            }
        ]
    }
];